<template>
    <el-card class="myLesson">
        <div class="flex-layout">
            <div v-for="(item,i) in lessonList" :key="i" class="p-pointer" @click="$router.push({path:'/home/lessons/study',query:{id:item.id,title:item.name}})">
                <LessonCard :data="item" class="lesson p-pointer"/>
            </div>
        </div>
        <div class="page">
            <el-pagination v-loading="loading" background hide-on-single-page @current-change="currentChange" :current-page="page" layout="prev, pager, next" :total="totalLength" :page-size="10">
            </el-pagination>
        </div>
    </el-card>
</template>
<script>
import LessonCard from '@p/components/lessonCard';
export default {
    components:{ LessonCard },
    data() {
        return{
            lessonList: [],
            page: 1,
            totalLength: 0,
            loading: false,
        }
    },
    created(){
        this.getMyTeach(1)
    },
    methods: {
        async getMyTeach(page){
            this.loading = true;
            await this.$http.personal.getMyTeach({page:page,page_size:10}).then(res=>{
                if(res.status === 200){
                    this.loading = false;
                    let resData = res.data.data;
                    this.totalLength = resData.total;
                    this.lessonList = resData.data;
                    this.$emit('goAnchor','#anchor2')
                    this.$emit('countNum')
                }
            }).catch(v=>{})
        },
        currentChange(page){
            this.page = page;
            this.getMyTeach(page)
        }
    }
}
</script>
<style lang="less" scoped>
.lesson{
    margin: 12px 3px 12px 3px !important;
}
.page{
    display: flex;
    justify-content: center;
}
</style>